<template>
  <div>
    <div class="intro-y text-3xl font-bold mt-6 mb-5">Team</div>

    <div class="text-xl">IT</div>
    <div class="grid grid-cols-12 gap-6 my-5">
      <Card
        class="intro-y col-span-12 md:col-span-6 lg:col-span-4"
        name="Fernando Berzal"
        title="Head of Technology"
        email="fberzal@accipartners.com"
        photo="fernando.png"
      >
        <p>
          Fernando Berzal, Ph.D., teaches Computational Intelligence and
          Information Systems Engineering at the Department of Computer Science
          and Artificial Intelligence at the University of Granada (Spain). He
          holds a Ph.D. in data mining and he was awarded the Computer Science
          Studies National First Prize by the Spanish Ministry of Education. He
          has been a visiting research scientist at the University of Illinois
          at Urbana-Champaign and he is a Senior Member of the Association for
          Computing Machinery (ACM). His research interests include Artificial
          Intelligence, complex networks, and deep learning, as well as
          model-driven software development, software design, and the
          application of data mining techniques to engineering problems. He has
          coauthored dozens of research papers on machine learning, data
          mining, complex networks, natural language processing, and software
          engineering. His research work has been featured in top research
          journals such as Machine Learning, Data Mining &amp; Knowledge
          Discovery, ACM Computing Surveys, IEEE Transactions on Data &amp;
          Knowledge Engineering, Complexity, IEEE Software, Communications of
          the ACM, Information Sciences, Knowledge &amp; Information Systems,
          Data &amp; Knowledge Engineering, Expert Systems with Applications,
          or the Journal of Computational Science, to name a few. He is also
          the author of a top-selling deep learning textbook in Spanish,
          currently used at multiple Spanish-speaking universities.
        </p>
      </Card>

      <Card
        class="intro-y col-span-12 md:col-span-6 lg:col-span-4"
        name="Rafael Nogales"
        title="Senior Technology Officer"
        email="rnogales@accipartners.com"
        photo="rafael-nogales.jpg"
      >
        <p>
          Rafael Nogales holds two Bachelor's Degrees, one in
          Mathematics and another in Computer Science, both from the University
          of Granada. He also holds a Master's Degree in Intelligence Analysis
          from LISA Institute.
        </p>

        <p>
          He has more than 10 years of experience in software development,
          working with disruptive technologies such as Cloud Computing,
          Distributed Systems, and Artificial Intelligence, as well as leading
          engineering teams for multinational companies and international
          organizations including Alight, Informa, Swiss Re, Shell, ASML, and
          NATO.
        </p>

        <p>
          He has worked across highly regulated and sensitive industries
          including Human Resources, Finance, Risk Management, Insurance,
          Pharmaceutical, Energy, Semiconductors, and Defense. He has
          participated in key international projects such as the deployment of
          Palantir solutions at Swiss Re for agriculture and housing
          reinsurance, energy compliance and data pipeline initiatives at Shell
          following the disruptions caused by the war in Ukraine, reliability
          improvements for ASML EUV machines used by Samsung, Intel, and TSMC
          foundries, and Project Maven initiatives for NATO.
        </p>

        <p>
          He has also worked as a lecturer at different universities, teaching
          courses in Cybersecurity, Artificial Intelligence, and Financial
          Derivatives.
        </p>

        <p>
          He has a strong interest in finance, particularly in quantitative
          investing strategies based on macroeconomic data analysis. Privately,
          he has managed his own investment portfolio for more than 10 years
          following similar principles, combined with the use of financial
          options strategies.
        </p>

        <p>
          He has worked in Switzerland, the Netherlands, and Spain. He speaks
          Spanish, English, and French.
        </p>
      </Card>
    </div>

    <div class="text-xl mt-14">Business Development</div>
    <div class="grid grid-cols-12 gap-6 mt-5">
      <Card
        class="intro-y col-span-12 md:col-span-6 lg:col-span-4"
        name="Jesús Gil"
        email="jgil@accipartners.com"
        photo="jesus-gil.jpg"
      >
        <p>
          Jesus holds a Law Degree and has a Master's degree from the
          prestigious College of Europe in Bruges (Belgium) in European
          Politics and Economics, with a scholarship from the Spanish Ministry
          of Foreign Affairs. He speaks English, French and Spanish.
        </p>

        <p>
          He worked from 2001 to 2006 in international organizations such as
          the World Trade Organization in Geneva and the European Commission in
          Brussels. From 2006 to 2008 he worked as private banker in Citi
          Switzerland for LATAM region; from 2008 until 2018 he worked at UBS
          Wealth Management in Geneva as business developer covering MFO in the
          LATAM region and Southern Europe.
        </p>
      </Card>

      <Card
        class="intro-y col-span-12 md:col-span-6 lg:col-span-4"
        name="Antonio de la Oliva"
        email="adelaoliva@accipartners.com"
        photo="antonio-delaoliva.jpg"
      >
        <p>
          Antonio de la Oliva has worked at Alchemia EAFI during the last few
          years advising HNWI on their Fixed Income strategies. He has helped
          to design optimal asset allocation models depending on each client's
          profile. Prior to joining Alchemia, he worked in New York for BCP
          Securities LLC, a boutique investment bank focused on Emerging Market
          debt.
        </p>

        <p>
          He has also worked for KPMG. Antonio holds a degree in Business
          Administration from Universidad Pontificia de Comillas ICADE (E2) and
          a Master in Accounting from Instituto de Estudios Bursátiles (IEB).
        </p>

        <p>
          He speaks Spanish and English.
        </p>
      </Card>

      <Card
        class="intro-y col-span-12 md:col-span-6 lg:col-span-4"
        name="Manuel Gil"
        email="mgil@accipartners.com"
        photo="manuel-gil.jpg"
      >
        <p>
          Manuel is a senior banker with over 20 years of experience in
          international DCM (Debt Capital Markets), with strong in depth
          knowledge of Emerging Markets fixed income. He started his career in
          2000 in New York as market analyst for the Trade Commission of Spain.
          From 2001 to 2006, he worked for Santander (Banesto) as proprietary
          trader, managing a 300 MM EUR book of LBO loans. In 2006 he joins BCP
          Securities LLC, an American boutique investment bank focused in EM
          bonds, as senior partner. He was a sales trader of High Yield and
          Emerging Markets bonds, covering European institutional clients. He
          is part of ACCI’s portfolio management team. He holds a degree in
          Economics from Universidad de Granada, postgraduate studies from
          University of Miami and FINRA Series 7, 24 and 65 Certificates.
        </p>

        <p>
          He speaks Spanish, English and French.
        </p>
      </Card>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Card from './Card.vue'

export default defineComponent({
  components: { Card },
})
</script>

<style lang="scss" scoped>
p {
  @apply mb-3;
}
</style>
